import react from 'react';
import moment from 'moment';
import styled from '@emotion/styled';
import { IoIosArrowForward } from 'react-icons/io';

import { ISendHistoryItem } from 'types/salary';

const Wrap = styled.div`
  z-index: 2;
  position: relative;
  display: flex;
  margin-top: 30px;
  width: 100%;
  flex-direction: column;
  border-radius: 12px;
  background-color: #fff;
`;
const TableArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const Table = styled.table`
  min-width: 500px;
  border-collapse: collapse;

  thead {
    background-color: #fbfef6;
  }

  th {
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    border: 1px solid #ddd;

    span {
      font-size: 0.8rem;
    }
  }

  td {
    padding: 10px 20px;
    text-align: center;
    border: 1px solid #ddd;
  }
`;

const TableBody = styled.div`
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: scroll;
`;

interface IProps {
  data: ISendHistoryItem[];
  enterDetailPayPage: (pkIndex: number) => void;
}

const SendHistoryTable = ({ data, enterDetailPayPage }: IProps) => {
  return (
    <Wrap>
      <TableArea>
        <Table>
          <colgroup>
            <col width="50%" />
            <col width="35%" />
            <col width="15%" />
          </colgroup>
          <thead>
            <tr>
              <th>전송일자</th>
              <th>전송시간</th>
              <th>내역보기</th>
            </tr>
          </thead>
        </Table>
        <TableBody>
          <Table style={{ width: 'calc(100% + 10px)' }}>
            <colgroup>
              <col width="50%" />
              <col width="35%" />
              <col width="15%" />
            </colgroup>
            <tbody>
              {data.map((item, index) => {
                if (item.PUSH_DATE !== '-') {
                  return (
                    <tr key={index}>
                      <td>{moment(item.PUSH_DATE.split(' ')[0]).format('YYYY년 MM월 DD일')}</td>
                      <td>{item.PUSH_DATE.split(' ')[1]}</td>
                      <td
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          enterDetailPayPage(item.PK_INDEX);
                        }}>
                        <IoIosArrowForward />
                      </td>
                    </tr>
                  );
                } else {
                  return null;
                }
              })}
            </tbody>
          </Table>
        </TableBody>
      </TableArea>
    </Wrap>
  );
};

export default SendHistoryTable;
